import React from "react";

function VideoBackground({ src, className = "", videoId = "backgroundVideo" }) {
    if (!src) return null;

    return (
        <video autoPlay muted loop playsInline id={videoId} className={className}>
            <source src={src} type="video/mp4" />
        </video>
    );
}

export default VideoBackground;
